import React, { useState } from 'react';

const AddContactModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ name: '', position: '', company: '', email: '', phone: '', status: 'cold' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ name: '', position: '', company: '', email: '', phone: '', status: 'cold' });
  };

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="add-contact-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">+</div>
        <div className="modal-title">Tambahkan Kontak</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>Masukkan data kontak client terbaru.</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nama Lengkap</label>
            <input type="text" className="form-control" required placeholder="Contoh: Rina Melati"
              value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
              data-testid="add-contact-name" />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Posisi</label>
              <input type="text" className="form-control" required placeholder="CTO"
                value={form.position} onChange={e => setForm({ ...form, position: e.target.value })}
                data-testid="add-contact-position" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Perusahaan</label>
              <input type="text" className="form-control" required placeholder="PT. Inovasi"
                value={form.company} onChange={e => setForm({ ...form, company: e.target.value })}
                data-testid="add-contact-company" />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Email</label>
              <input type="email" className="form-control" required placeholder="rina@inovasi.com"
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                data-testid="add-contact-email" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Telepon</label>
              <input type="text" className="form-control" required placeholder="+62 812..."
                value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
                data-testid="add-contact-phone" />
            </div>
          </div>
          <div className="form-group">
            <label>Status Kontak</label>
            <select className="form-control form-select" value={form.status}
              onChange={e => setForm({ ...form, status: e.target.value })}
              data-testid="add-contact-status">
              <option value="hot">Hot</option>
              <option value="warm">Warm</option>
              <option value="cold">Cold</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="add-contact-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="add-contact-submit">Simpan Kontak</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContactModal;
